import { render, staticRenderFns } from "./ProviderFilterMenu.vue?vue&type=template&id=35c32a74&scoped=true"
import script from "./ProviderFilterMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderFilterMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProviderFilterMenu.vue?vue&type=style&index=0&id=35c32a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c32a74",
  null
  
)

export default component.exports